/* eslint-disable react/prop-types */
import React from 'react';
import { withAbsoluteContainer } from '@Utils/components';
import TextareaAutosize from 'react-autosize-textarea';
import { useIntl } from 'react-intl';

const textAreaContainerStyle: React.CSSProperties = {
	position: 'relative',
	display: 'flex',
	flex: 1,
	padding: 10,
};

type Props = {
	maxRows?: number;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	rightComponent?: React.ReactNode;
	error?: string;
	containerClassName?: string;
	contentClassName?: string;
	textAreaContainerStyleCustom?: React.CSSProperties;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export default function TextArea({
	rightComponent,
	leftIcon,
	rightIcon,
	textAreaContainerStyleCustom,
	error,
	containerClassName = '',
	contentClassName = '',
	className = '',
	...props
}: Props) {
	leftIcon = leftIcon ? withAbsoluteContainer(leftIcon, 'left') : undefined;
	rightIcon = rightIcon ? withAbsoluteContainer(rightIcon, 'right') : undefined;
	const intl = useIntl();
	return (
		<div className={containerClassName}>
			<div style={{ display: 'flex' }}>
				<div
					style={textAreaContainerStyleCustom || textAreaContainerStyle}
					className={`form-control form-control-solid textarea-parent ${contentClassName}`}
				>
					{leftIcon}
					<TextareaAutosize
						className={`form-control form-control-solid custom-textarea ${className}`}
						style={{ backgroundColor: 'transparent' }}
						{...props}
					/>
					{rightIcon}
				</div>
				{rightComponent}
			</div>
			{error ? (
				<div className="error-message mt-3">
					{intl.formatMessage({ id: error })}
				</div>
			) : null}
		</div>
	);
}
